import Vue from 'vue';
import Config from '@/config';

// Global Mixin: Careful when making a function!
Vue.mixin({
  methods: {
    LOG: message => {
      // eslint-disable-next-line no-console
      return Config.ENV == 'production' ? () => {} : console.log(message);
    }
  }
});
